// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._17GC1TauTRhzgsorEMqKfh{display:flex;align-items:center}._2Y-EZm-iPwLkBaYnbUbimb{flex-grow:1;margin:0 1rem}._3PDj_2Yuqp7SRKNPVlA4VY{min-width:7.5rem;font-size:1.4rem}._3-AD_G4KXJ2HM51gOmZs-{margin-right:.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_17GC1TauTRhzgsorEMqKfh",
	"bar": "_2Y-EZm-iPwLkBaYnbUbimb",
	"label": "_3PDj_2Yuqp7SRKNPVlA4VY",
	"intervals": "_3-AD_G4KXJ2HM51gOmZs-"
};
module.exports = ___CSS_LOADER_EXPORT___;
